//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    headers: Array,
    isErros: Boolean,
    registros: Array,
    title: String,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    possuiData() {
      return this.headers.filter(header => header.text === 'data').length > 0;
    },
  },
  methods: {
    openDialogErros(row) {
      this.$emit('IMPORTACAOTABELA_OPEN_DIALOG_ERROS', row);
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/importacao/ImportacaoTabela.vue?vue&type=script&lang=js&